import { IoIosAttach } from "react-icons/io";
import send from "../../../assets/paper-plane.png";

const SendButton = ({
  isEditingMessage,
  setIsEditingMessage,
  setIdToEdit,
  setMessage,
  handleSaveEditedMessage,
  createNewMessage,
  resetMessage,
  incrementUnreadMessages,
  message,
  messageFiles,
  replyingTo,
  uploadFileViaButton,
  validPreviewExtensions,
  documentPreviewIcon,
  setMessageFiles,
}) => {
  return (
    <div
      style={{
        position: "absolute",
        bottom: "22px",
      }}
    >
      <button
        className="send-chatbar-button2 fw-700 fs-16 lh-2371"
        onClick={async () => {
          if (isEditingMessage) {
            setIsEditingMessage(false);
            setIdToEdit(null);
            setMessage("");
            handleSaveEditedMessage();
          } else {
            await createNewMessage();
            resetMessage();
            incrementUnreadMessages();
          }
        }}
        disabled={/^\s*$/.test(message) && messageFiles.length === 0}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          {isEditingMessage ? "Edit" : "Send"}
          {isEditingMessage ? (
            <i
              style={{ marginLeft: "16px" }}
              className="fa-regular fa-pen fs-20"
            ></i>
          ) : (
            <img
              src={send}
              alt="Paper plane"
              style={{ height: "20px", marginLeft: "12px" }}
              className=""
            ></img>
          )}
        </div>
      </button>
      {isEditingMessage && (
        <button
          style={{ height: "50px", marginLeft: "10px" }}
          className="btn-secondary fw-700 fs-16 lh-2371"
          onClick={() => {
            resetMessage();
            setMessage("");
          }}
          disabled={/^\s*$/.test(message) && messageFiles.length === 0}
        >
          <div style={{ display: "flex", alignItems: "center" }}>Cancel</div>
        </button>
      )}
      {replyingTo && (
        <button
          style={{ height: "50px", marginLeft: "10px" }}
          className="btn-secondary fw-700 fs-16 lh-2371"
          onClick={() => {
            resetMessage();
            setMessage("");
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>Cancel</div>
        </button>
      )}

      <input
        type="file"
        id="attachFile"
        style={{ display: "none" }}
        onChange={uploadFileViaButton}
      />

      {!isEditingMessage && (
        <IoIosAttach
          role="button"
          onClick={() => document.getElementById("attachFile").click()}
          size="23px"
          style={{
            marginLeft: "28px",
            marginTop: "13.5px",
            position: "absolute",
          }}
        />
      )}

      <div
        style={{
          minHeight: "11px",
          marginBottom: "32px",
          position: "absolute",
          bottom: "-40px",
          left: replyingTo ? "290px" : "200px",
        }}
        className="d-flex flex-row"
      >
        {messageFiles.map((file, idx) => {
          const isFile = !validPreviewExtensions.some((extension) =>
            file.name.endsWith(extension),
          );
          return (
            <div key={idx} className="send-chatbar-image-container">
              <img
                alt={file.name}
                height="54px"
                width="54px"
                src={isFile ? documentPreviewIcon : file.preview}
              />
              {isFile && (
                <div className="send-chatbar-image-container-text">
                  <h5>{file.name}</h5>
                </div>
              )}
              <button
                onClick={() => {
                  setMessageFiles((prevState) =>
                    prevState.filter((_, i) => i !== idx),
                  );
                }}
              >
                X
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SendButton;
